import { types } from '../constants'

const index = {
  pending: `${types.listPublishers}_PENDING`,
  fulfilled: `${types.listPublishers}_FULFILLED`,
  rejected: `${types.listPublishers}_REJECTED`
}

export const listPublishers = {
  [index.pending]: ({ draft }: ActionData) => {
    draft.advertiserPublisher.publishers.loading = true
    draft.advertiserPublisher.publishers.error = null
  },
  [index.fulfilled]: ({ draft, action }: GetAdvertiserPublishersFulfilled) => {
    draft.advertiserPublisher.publishers.data = action.payload.publishers.map(
      item => ({
        ...item,
        id: item.publisher_id,
        name: item.publisher_name
      })
    )

    draft.advertiserPublisher.publishers.loading = false
    draft.advertiserPublisher.publishers.error = null
  },
  [index.rejected]: ({ draft, action }: ActionDataRejected) => {
    draft.advertiserPublisher.publishers.loading = false
    draft.advertiserPublisher.publishers.error = action.payload
  }
}
